import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Anchor = createReactComponent("Anchor", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "5",
  r: "3",
  key: "19a85e"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12",
  y2: "8",
  key: "rq7cvc"
}], ["path", {
  d: "M5 12H2a10 10 0 0020 0h-3",
  key: "yc0v05"
}]]]);
export default Anchor;